<template>
	<div v-if="visible" class="forward-detail-overlay">
		<div class="forward-detail-container">
			<!-- 头部 -->
			<div class="forward-detail-header">
				<div class="header-left" @click="handleClose">
					<i class="el-icon-arrow-left back-btn"></i>
					<span class="title">聊天记录</span>
				</div>
			</div>

			<!-- 消息列表 -->
			<div class="forward-detail-content" ref="messageList">
				<div class="message-list">
					<div v-for="(msg, index) in normalizedMessages" :key="index">
						<chat-message-item
							:mine="false"
							:headImage="msg._avatar || ''"
							:showName="msg._displayName || '未知'"
							:msgInfo="msg"
							:groupMembers="[]"
							:menu="false"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import ChatMessageItem from './ChatMessageItem.vue';

export default {
	name: 'ForwardMessageDetail',
	components: {
		HeadImage,
		ChatMessageItem
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		forwardData: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			// 记录打开面板时的会话ID，用于检测会话切换
			initialChatId: null
		};
	},
	computed: {
		// 当前活跃会话
		activeChat() {
			return this.$store.state.chatStore.activeChat;
		},
		// 将转发/引用消息统一转换为 ChatMessageItem 所需的 msgInfo 格式
		normalizedMessages() {
			if (!this.forwardData || !this.forwardData.messages) return [];
			return this.forwardData.messages.map((msg, index) => ({
				...msg,
				id: msg.id || `detail-${index}`,
				sendId: msg.senderId || msg.sendId || 0,
				sendTime: msg.timestamp || msg.sendTime || 0,
				type: msg.type || 0,
				selfSend: false,
				status: 1,
				// 内部字段供 headImage / showName props 使用
				_displayName: msg.senderName || msg.sendNickName || '未知',
				_avatar: msg.senderAvatar || msg.headImage || ''
			}));
		}
	},
	watch: {
		// 监听面板显示状态，记录初始会话ID
		visible(newVal) {
			if (newVal && this.activeChat) {
				this.initialChatId = this.activeChat.targetId || this.activeChat.id;
				console.log('[ForwardMessageDetail] 面板打开，记录初始会话ID:', this.initialChatId);
			}
		},
		// 监听会话切换，当会话变化时自动关闭面板
		activeChat: {
			handler(newChat) {
				if (!this.visible || this.initialChatId === null) return;

				if (newChat) {
					const newChatId = newChat.targetId || newChat.id;
					if (newChatId !== this.initialChatId) {
						console.log('[ForwardMessageDetail] 检测到会话切换，自动关闭面板');
						console.log('[ForwardMessageDetail] 原会话ID:', this.initialChatId, '新会话ID:', newChatId);
						this.handleClose();
					}
				}
			},
			immediate: false
		}
	},
	methods: {
		handleClose() {
			this.$emit('close');
		}
	}
};
</script>

<style lang="scss" scoped>
.forward-detail-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	z-index: 100;
	display: flex;
	flex-direction: column;
}

.forward-detail-container {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.forward-detail-header {
	height: 50px;
	border-bottom: 1px solid #e8e8e8;
	display: flex;
	align-items: center;
	padding: 0 20px;
	background: #fff;

	.header-left {
		display: flex;
		align-items: center;
		gap: 8px;
		cursor: pointer;
		color: #333;

		.back-btn {
			font-size: 18px;
			line-height: 1;
		}

		.title {
			font-size: 16px;
			font-weight: 500;
			line-height: 1;
		}
	}
}

.forward-detail-content {
	flex: 1;
	overflow-y: auto;
	padding: 20px;
	background: #f5f5f5;
}

.message-list {
	max-width: 800px;
	margin: 0 auto;
}
</style>
